import React from 'react';
import { motion } from 'framer-motion';

const Benefits = () => {
  const benefits = [
    {
      icon: '🎯',
      title: 'Aprendizaje Personalizado',
      description: 'Desarrollamos nuestros programas de acuerdo a tus metas y necesidades para que las alcances cuanto antes.'
    },
    {
      icon: '🌟',
      title: 'Horarios Flexibles',
      description: 'Aprende a tu ritmo con clases disponibles en diferentes horarios durante la semana.'
    },
    {
      icon: '💬',
      title: 'Docentes Dinámicos',
      description: 'Cada docente tiene un nivel C2 o equivalente a Nativo para que aprendas con los mejores recursos.'
    },
    {
      icon: '🌍',
      title: 'Comunidad Global',
      description: 'Conecta con estudiantes alrededor del mundo y practica en un ambiente de soporte y amistad.'
    },
    {
      icon: '📈',
      title: 'Progreso Real',
      description: 'Recibe tests, feedbacks y tips de forma constante por parte de tus docentes y tus asesores.'
    },
    {
      icon: '💰',
      title: 'Precios Accesibles',
      description: 'Educación de calidad a precios competitivos, con planes flexibles para cada estudiante.'
    }
  ];

  return (
    <section id="benefits" className="py-20 bg-gradient-to-br from-pink-primary/10 to-yellow-primary/10">
      <div className="container mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl md:text-5xl font-league-spartan font-bold text-black mb-6">
            Lo que los Estudiantes <span className="text-red-primary">aman</span> de OEC
          </h2>
          <div className="w-24 h-1 bg-yellow-primary mx-auto mb-8"></div>
          <p className="text-xl text-gray-700 max-w-3xl mx-auto">
            Descubre las ventajas que hacen a OEC la opción perfecta para ti
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {benefits.map((benefit, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              viewport={{ once: true }}
              whileHover={{ y: -10, scale: 1.02 }}
              className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 group"
            >
              <motion.div
                className="text-5xl mb-6 text-center"
                whileHover={{ scale: 1.2, rotate: 10 }}
                transition={{ duration: 0.3 }}
              >
                {benefit.icon}
              </motion.div>
              
              <h3 className="text-xl font-semibold text-black mb-4 text-center group-hover:text-red-primary transition-colors duration-300">
                {benefit.title}
              </h3>
              
              <p className="text-gray-600 text-center leading-relaxed">
                {benefit.description}
              </p>

              <motion.div
                className="w-full h-1 bg-gradient-to-r from-pink-primary to-red-primary mt-6 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300"
                initial={{ scaleX: 0 }}
                whileInView={{ scaleX: 1 }}
                transition={{ duration: 0.8, delay: index * 0.1 + 0.3 }}
                viewport={{ once: true }}
              ></motion.div>
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.6 }}
          viewport={{ once: true }}
          className="text-center mt-16"
        >
          <div className="bg-white p-8 rounded-2xl shadow-lg max-w-4xl mx-auto">
            <h3 className="text-2xl font-semibold text-black mb-4">
              ¿List@ para la Experiencia OEC?
            </h3>
            <p className="text-gray-700 mb-6">
              Sé parte de la Mejor Academia en Inglés Online y cumple tus metas en poco tiempo.
            </p>
            <motion.button
              className="bg-red-primary text-white px-8 py-3 rounded-full font-semibold hover:bg-red-700 transition-colors duration-300 shadow-lg"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
            >
              Contactanos Hoy
            </motion.button>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Benefits;